import React, { useState, useRef } from 'react';
import api from '../../api';
import { useToast } from '../UI/ToastContext';

const StyleImportExport = ({ onImportComplete, styles }) => {
  const [importStatus, setImportStatus] = useState({ loading: false, message: '', error: false });
  const fileInputRef = useRef(null);
  const { showError } = useToast();

  // Gestion de l'export
  const handleExport = async () => {
    try {
      // Utiliser l'API pour télécharger le fichier
      // Cette méthode va provoquer un téléchargement du fichier
      window.open(`${process.env.REACT_APP_API_BASE_URL}/api/admin/styles/export`, '_blank');
    } catch (error) {
      console.error('Erreur lors de l\'export:', error);
      showError('Erreur lors de l\'export des styles');
    }
  };

  // Gestion de l'import
  const handleImport = async (e) => {
    e.preventDefault();
    
    const fileInput = fileInputRef.current;
    if (!fileInput || !fileInput.files || !fileInput.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', fileInput.files[0]);
    
    setImportStatus({ loading: true, message: 'Import en cours...', error: false });
    
    try {
      const response = await api.post('/api/admin/styles/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const { added, skipped } = response.data;
      setImportStatus({
        loading: false,
        message: `Import réussi ! Ajoutés: ${added}, Ignorés: ${skipped}`,
        error: false
      });
      
      // Rafraîchir la liste des styles
      if (onImportComplete) {
        onImportComplete();
      }
      
      // Réinitialiser le champ de fichier
      fileInput.value = '';
    } catch (error) {
      console.error('Erreur lors de l\'import:', error);
      setImportStatus({
        loading: false,
        message: error.response?.data?.error || 'Erreur lors de l\'import',
        error: true
      });
    }
  };

  return (
    <div className="panel panel-secondary" style={{ marginTop: '20px' }}>
      <h3 className="panel-title">Import / Export</h3>
      
      <div className="panel-content">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start' }}>
          {/* Section Export */}
          <div className="sub-panel" style={{ flex: '1 1 300px' }}>
            <h4>Exporter les styles</h4>
            <p className="mb-3">Télécharger tous les styles ({styles.length}) au format JSON.</p>
            <button 
              className="btn btn-secondary" 
              onClick={handleExport}
              disabled={styles.length === 0}
            >
              Télécharger JSON
            </button>
          </div>
          
          {/* Section Import */}
          <div className="sub-panel" style={{ flex: '1 1 300px' }}>
            <h4>Importer des styles</h4>
            <p className="mb-3">Importer des styles depuis un fichier JSON.</p>
            
            <form onSubmit={handleImport} style={{ marginBottom: '10px' }}>
              <div className="form-group">
                <input 
                  type="file" 
                  ref={fileInputRef}
                  accept=".json"
                  className="form-control"
                  disabled={importStatus.loading}
                />
                <small className="form-text">
                  Sélectionnez un fichier JSON avec le format approprié.
                </small>
              </div>
              
              <button 
                type="submit" 
                className="btn btn-secondary"
                disabled={importStatus.loading}
              >
                {importStatus.loading ? 'Importation...' : 'Importer'}
              </button>
            </form>
            
            {importStatus.message && (
              <div 
                className={`panel ${importStatus.error ? 'panel-dotted' : 'panel-dashed'}`}
                style={{ 
                  padding: '10px',
                  color: importStatus.error ? 'var(--color-error)' : 'var(--color-secondary)'
                }}
              >
                {importStatus.message}
              </div>
            )}
          </div>
        </div>
        
        <div className="mt-3">
          <h4>Format JSON attendu</h4>
          <pre style={{ 
            background: 'rgba(0,0,0,0.2)', 
            padding: '10px', 
            borderRadius: 'var(--border-radius-md)',
            overflow: 'auto'
          }}>
{`[
  {
    "name": "Nom du style",
    "category": "Catégorie",
    "description": "Description...",
    "image_url": "https://exemple.com/image.jpg",
    "prompt": "Prompt à utiliser pour ce style",
    "token_cost": 1,
    "is_active": true,
    "format": "square"
  },
  ...
]`}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default StyleImportExport; 